import React from 'react';
import './TrackerSection.css';

const TimePills = ({ value, onChange, options }) => (
  <div className="tracker-pills" role="tablist" aria-label="Time range">
    {options.map(opt => (
      <button
        key={opt.value}
        role="tab"
        aria-selected={value === opt.value}
        className={`tracker-pill ${value === opt.value ? 'is-active' : ''}`}
        onClick={() => onChange(opt.value)}
        type="button"
      >
        {opt.label}
      </button>
    ))}
  </div>
);

const StatCards = ({ stats }) => (
  <div className="tracker-stats">
    {stats.map((stat, i) => (
      <div key={i} className="tracker-stat">
        <div className="tracker-stat-label">{stat.label}</div>
        <div
          className={`tracker-stat-value${
            stat.trend === 'up' ? ' is-up' : stat.trend === 'down' ? ' is-down' : ''
          }`}
        >
          {stat.trend === 'up' && <span aria-hidden="true">▲ </span>}
          {stat.trend === 'down' && <span aria-hidden="true">▼ </span>}
          {stat.value}
        </div>
      </div>
    ))}
  </div>
);

export const TrackerSection = ({
  label,
  title,
  timeRange,
  onTimeRangeChange,
  timeRangeOptions,
  stats,
  source,
  cadence,
  loading,
  error,
  children,
}) => {
  return (
    <section className="tracker-section">
      <header className="tracker-section-header">
        <div className="tracker-section-titleblock">
          <div className="tracker-section-label">{label}</div>
          <h2 className="tracker-section-title">{title}</h2>
        </div>
        {timeRangeOptions && (
          <TimePills
            value={timeRange}
            onChange={onTimeRangeChange}
            options={timeRangeOptions}
          />
        )}
      </header>

      <div className="tracker-chart-wrap">
        {loading ? (
          <div className="tracker-state">Loading…</div>
        ) : error ? (
          <div className="tracker-state tracker-state-error">{error}</div>
        ) : (
          children
        )}
      </div>

      {stats && <StatCards stats={stats} />}

      <div className="tracker-divider" />

      <footer className="tracker-section-footer">
        <span className="tracker-section-source">{source}</span>
        {cadence && <span className="tracker-section-cadence">{cadence}</span>}
      </footer>
    </section>
  );
};
